import React from 'react';
import {subfolder} from "../utils/constants";

// Remplit la vue : flex item de .ant-spin-container (chaîne flex .view-spin dans App.css), pas de calc à maintenir
const sectionStyle = {
  flex: "1 0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const logoStyle = {
  opacity: 0.5,
};

const Accueil = () => {
  return (
      <section style={sectionStyle}>
        <img src={`${subfolder}/aster-noir.png`} alt="Aster" style={logoStyle} />
      </section>
  );
};

export default Accueil;
